import React, { FC, useCallback } from 'react';

import ConditionRow from './ConditionRow';
import { DueInCondition as DueInConditionType } from 'src/actions/rules/condition';
import DueInSection, { getDueInStatusLabel } from '../shared/DueInSection';

type DueInConditionProps = {
  condition: DueInConditionType;
  index: number;
  isReadOnly?: boolean;
  onDelete: Function;
  onUpdate: Function;
};

const DueInCondition: FC<DueInConditionProps> = ({ condition, index, isReadOnly, onDelete, onUpdate }) => {
  const onDueStatusChange = useCallback(
    status => {
      const dueValue = condition.value;
      dueValue.setStatus(status);
      condition.setValue(dueValue);
      onUpdate({ condition, index });
    },
    [condition, index, onUpdate]
  );

  const onMinutesChange = useCallback(
    evt => {
      const minutes = parseInt(evt.target.value);
      if (isNaN(minutes) || minutes <= 0) return;

      const dueValue = condition.value;
      dueValue.setMinutes(minutes);
      condition.setValue(dueValue);
      onUpdate({ condition, index });
    },
    [condition, index, onUpdate]
  );

  const value = condition.value;

  return (
    <ConditionRow index={index} isReadOnly={isReadOnly} onDelete={onDelete} text="Due Date is">
      {isReadOnly ? (
        <span data-aid="readOnlyDueInValue">{renderDueDateValue()}</span>
      ) : (
        <DueInSection value={value} onDueStatusChange={onDueStatusChange} onMinutesChange={onMinutesChange} />
      )}
    </ConditionRow>
  );

  function renderDueDateValue() {
    const label = getDueInStatusLabel(value.status);

    if (value.minutes === 0) {
      return label;
    }

    const minutesValue = Math.abs(value.minutes);
    return (
      <>
        {label} {minutesValue} {`Minute${minutesValue > 1 ? 's' : ''}`}
      </>
    );
  }
};

export default DueInCondition;
